import {__, data, isdata, isstring} from "@deckchair-technicians/vice";

@data
export class TemporarySqsCredentials {
  AccessKeyId: string = __(isstring());
  SecretAccessKey: string = __(isstring());
  SessionToken: string = __(isstring());
}

@data
export class R4ServerData {
  sqsQueueUrl: string = __(isstring());
  sqsRegion: string = __(isstring());
  libraryVersion: string = __(isstring());
  sqsCredentials: TemporarySqsCredentials = __(isdata(TemporarySqsCredentials));
}
